/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Error_Save_FinalsInputs */



/**
* | output |
* | --- |
* | "Failed to save finals scores" |
*
* @param {Tournament_Error_Save_FinalsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_error_save_finals = /** @type {((inputs?: Tournament_Error_Save_FinalsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Error_Save_FinalsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l'enregistrement des scores de finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al guardar puntuaciones de finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao salvar pontuações das finais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio punteggi finali fallito")
	return /** @type {LocalizedString} */ ("Failed to save finals scores")
});